import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6">
      <h1 className="text-5xl font-bold text-red-600 mb-4">403</h1>
      <h2 className="text-2xl font-semibold mb-2">Unauthorized</h2>
      <p className="mb-6">You don’t have permission to access this page.</p>
      <Link
        to="/"
        className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 transition"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default UnauthorizedPage;
